"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// from https://gist.github.com/ca0v/73a31f57b397606c9813472f7493a940
var debounce = function (cb, wait) {
    if (wait === void 0) { wait = 20; }
    var timer;
    var callable = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        clearTimeout(timer);
        timer = setTimeout(function () { return cb.apply(void 0, args); }, wait);
    };
    return callable;
};
exports.default = debounce;
